import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

export function Hero() {
  const [, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToQuote = () => {
    const quoteSection = document.getElementById('quote-form');
    if (quoteSection) {
      quoteSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToPortfolio = () => {
    const portfolioSection = document.getElementById('portfolio');
    if (portfolioSection) {
      portfolioSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Hero Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/fe6e72fd4aefdc202ab4b7b11ee1b79b.jpg"
          alt="Premium illuminated commercial signage Arlington TX"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/70"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/30"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 flex items-center justify-center min-h-screen">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full text-center pt-24">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2 mb-8">
              <div className="w-2 h-2 bg-orange-400 rounded-full"></div>
              <span className="text-white/90 text-sm font-medium">
                Arlington&apos;s Premier Custom Sign Shop
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
              Custom Signs That
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-orange-400">
                Get You Noticed
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto font-light">
              Creative Signage Solutions for Businesses of All Sizes in Arlington, TX
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={scrollToQuote}
                className="px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-lg font-semibold rounded-full hover:from-orange-600 hover:to-orange-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Request a Quote
              </button>
              <button
                onClick={scrollToPortfolio}
                className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-full hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
              >
                See Portfolio
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto"
          >
            <a
              href="tel:817-860-9310"
              className="bg-white/10 backdrop-blur-md rounded-2xl p-6 hover:bg-white/20 transition-all border border-white/20 cursor-pointer"
            >
              <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <h3 className="text-white font-semibold text-sm mb-1">Call Us</h3>
              <p className="text-white/80 text-xs">817-860-9310</p>
            </a>
            <button
              onClick={scrollToQuote}
              className="bg-white/10 backdrop-blur-md rounded-2xl p-6 hover:bg-white/20 transition-all border border-white/20 cursor-pointer"
            >
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <h3 className="text-white font-semibold text-sm mb-1">Get Quote</h3>
              <p className="text-white/80 text-xs">Fast Response</p>
            </button>
            <a
              href="https://www.google.com/maps/search/?api=1&query=32.708617,-97.147128&query_place_id=ChIJkRKWLsV8ToYRhAcULCMpvSc"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white/10 backdrop-blur-md rounded-2xl p-6 hover:bg-white/20 transition-all border border-white/20 cursor-pointer"
            >
              <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <h3 className="text-white font-semibold text-sm mb-1">Find Us</h3>
              <p className="text-white/80 text-xs">Arlington, TX</p>
            </a>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
